import apiClient from './apiClient';

/**
 * 📌 SERVICIO DE RESPUESTAS DE ENCUESTAS
 * Maneja las operaciones de encuestas de satisfacción
 */

/**
 * 📋 Guardar respuesta de encuesta
 * @param {Object} respuestaData - Datos de la respuesta
 * @returns {Promise<Object>} Respuesta de la API
 */
export const guardarRespuestaEncuesta = async (respuestaData) => {
  try {
    console.log('🔵 [respuestasEncuestasService] Enviando al backend:', respuestaData);
    const response = await apiClient.post('/respuestas_encuestas', respuestaData);
    console.log('🟢 [respuestasEncuestasService] Respuesta exitosa:', response.data);
    return {
      success: true,
      data: response.data
    };
  } catch (error) {
    console.error('🔴 [respuestasEncuestasService] Error completo:', error);
    console.error('🔴 [respuestasEncuestasService] Error response:', error.response);
    console.error('🔴 [respuestasEncuestasService] Error data:', error.response?.data);
    console.error('🔴 [respuestasEncuestasService] Error status:', error.response?.status);
    return {
      success: false,
      error: error.response?.data?.mensaje || error.message || 'Error al guardar la respuesta'
    };
  }
};

const respuestasEncuestasService = {
  guardarRespuestaEncuesta
};

export default respuestasEncuestasService;